import { RewardType } from 'models/RewardType';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useRewardTypeDictionaries = () => {
  const { t } = useTranslation();

  const rewardTypeDictionary = useMemo<Record<RewardType, string>>(
    () => ({
      [RewardType.Gold]: t('rewardType.gold'),
      [RewardType.Silver]: t('rewardType.silver'),
      [RewardType.Bronze]: t('rewardType.bronze'),
      [RewardType.None]: t('rewardType.none'),
    }),
    [t]
  );

  const revertedRewardDictionary = useMemo<Record<string, RewardType>>(
    () => ({
      [t('rewardType.gold')]: RewardType.Gold,
      [t('rewardType.silver')]: RewardType.Silver,
      [t('rewardType.bronze')]: RewardType.Bronze,
      [t('rewardType.none')]: RewardType.None,
    }),
    [t]
  );

  return { rewardTypeDictionary, revertedRewardDictionary };
};
